import {
  BigMaxIcon,
  BigMaxIconMobile,
} from '@kursk/components/ui/icons';
import { useOrientations } from "@common/hooks/useOrientation";
import { getComponentVersion } from "@kursk/utils/componentsTemplates";
import styles from "./MaxIcon.module.scss";

const componentsHash = {
  default: BigMaxIcon,
}

const componentsMobileHash = {
  default: BigMaxIconMobile,
}

export function MaxIconDefault() {
  const orientation = useOrientations();

  const componentVersion = getComponentVersion({ componentType: 'socialCardIconMax' });
  const Component = componentsHash[componentVersion] || componentsHash.default;
  const ComponentMobile = componentsMobileHash[componentVersion] || componentsMobileHash.default;

  return (
    <>
      {orientation === 'desktop' ? (
        <div className={styles.iconContainer}>
          <Component />
        </div>
      ) : (
        <div className={styles.iconContainerMobile}>
          <ComponentMobile />
        </div>
      )}
    </>
  )
}
